import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMessageFilled = (props) => /* @__PURE__ */ _jsx("svg", {
	height: 16,
	width: 16,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m16 2v11.432l-.615.568h-14.77l-.615-.601v-11.399zm-2 4.143v-1.143l-6 2.857-6-2.857v1.143l6 2.857z",
		fill: "#2b2b2b"
	})
});
export default SvgMessageFilled;
